import { action } from 'mobx';
import {
    TransactionBackofficeAPIApiFindAllTransactionsForBackofficeRequest,
    TransactionDto,
} from 'src/generated-api-client';
import { transactionApi } from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { AsyncOperationWithStatus } from 'src/utils/mobx/AsyncOperationWithStatus';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export type TransactionsFilter =
    ListFilter<TransactionBackofficeAPIApiFindAllTransactionsForBackofficeRequest>;

class TransactionsStoreClass extends BasicStore<
    TransactionDto,
    TransactionsFilter,
    TransactionDto,
    unknown,
    unknown
> {
    pager = new Pager();
    sorter = new Sorter<TransactionDto>();
    filterCriteria = new FilterCriteria<TransactionsFilter>();

    uploadLoader = new AsyncOperationWithStatus((file: File) => {
        return RequestHelper.unwrapFromAxiosPromise(
            transactionApi.importTransactionsForBackoffice({ file }),
        );
    });

    api: BasicStoreApi<TransactionDto, TransactionDto, unknown, unknown> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                transactionApi.findAllTransactionsForBackoffice(
                    {
                        page: this.pager.page,
                        size: this.pager.size,
                        sort: this.sorter.sort,
                        ...this.filterCriteria.filter,
                    },
                    options,
                ),
            );
            this.pager?.setTotal(response.totalElements ?? 0);

            return response.content ?? [];
        },
    };

    @action
    upload(file: File) {
        return this.uploadLoader.call(file);
    }
}

export const TransactionsStore = new TransactionsStoreClass();
